// Static route table for the area; pages load lazily (one chunk + its CSS).
// Portal users have list, create and edit. There is no show view, so a row
// opens the edit page (react-admin rowClick='edit').
import type { RouteObject } from 'react-router-dom'
import { lazyPages } from '../../app/lazyRoute'
import type { CrumbHandle } from '../../shell'

const page = lazyPages('src/features/portalusers/pages.tsx', () => import('./pages'))
const crumb = (text: string): CrumbHandle => ({ crumb: () => text })

export const portalUsersRoutes: RouteObject[] = [
  {
    path: 'portalusers',
    handle: crumb('Users & Roles'),
    children: [
      { index: true, lazy: page('PortalUserListPage') },
      { path: 'create', handle: crumb('Create'), lazy: page('PortalUserCreatePage') },
      {
        path: ':id',
        handle: { crumb: (match) => match.params.id ?? null } satisfies CrumbHandle,
        lazy: page('PortalUserEditPage')
      }
    ]
  }
]
